<script>
export default {
    name: 'ContentFullWidthImageBlock',
    props: {
        data: Object,
    },
    methods: {
        getSrcSet() {
            return this.data.image.sizes.large + ' ' + this.data.image.sizes['large-width'] + 'w, '
                + this.data.image.sizes.medium_large + ' ' + this.data.image.sizes['medium_large-width'] + 'w, '
                + this.data.image.sizes.medium + ' ' + this.data.image.sizes['medium-width'] + 'w';
        },
        getOrientation() {
            return this.data.image.width > this.data.image.height ? 'landscape' : 'portrait';
        }
    }
};
</script>

<template>
    <figure class="full-width-image">
        <img 
            v-bind:src="data.image.sizes.large" 
            v-bind:srcset="getSrcSet()"
            v-bind:alt="data.image.alt" 
            class="full-width-image__img"
            v-bind:class="'full-width-image__img--' + getOrientation()">
        <figcaption class="full-width-image__caption">{{ data.caption }}</figcaption>
    </figure>
</template>

<style lang="scss" scoped>
.full-width-image {
    margin: 12rem 0;
}
.full-width-image__img {
    display: block;
    width: 134.84626647%;
    margin-left: $layout-off-grid-width * -1;

    @include breakpoint('sm-down') {
        width: 100%;
        margin-left: 0;
    }
}
.full-width-image__img--portrait {
    width: 82.43045388%;
}
.full-width-image__caption {
    margin-top: 1.6rem;
    font-size: 1.6rem;
    letter-spacing: 0.033rem;
    line-height: 1.4375;
}
</style>
